import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, { API_ROUTES } from '../../../utils/constant';
import {
  Backdrop,
  Box,
  CircularProgress,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';

const ActivityLog = () => {
  const { gameId } = useParams();

  const [activityLog, setActivitiLog] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const itemsPerPage = 10;

  // Fetch shifts list based on selected role and team
  const fetchActivityLog = useCallback(async () => {
    const query: any = {
      page: currentPage,
      limit: itemsPerPage,
    };
    try {
      setLoading(true);
      const response = await HttpService.get(
        API_ROUTES.activityLog +
          `/${gameId}?${new URLSearchParams(query).toString()}`
      );
      setActivitiLog(response.data.data.list || []);
      setTotalPages(response.data.data.totalPages);
    } catch (error) {
      console.error('Error fetching shifts list:', error);
    } finally {
      setLoading(false);
    }
  }, [currentPage]);
  React.useEffect(() => {
    fetchActivityLog();
  }, [fetchActivityLog]);
  const entityNameMapping: { [key: string]: string } = {
    GAME_ASSIGN: 'Game assignee',
    GAME_STATUS_CHANGE: 'Game status',
    GAME_QC_ASSIGN: 'Game QC Moderator',
    PERIOD_START_TIME: 'Period start time',
  };

  const formatGameStatusChange = (data: any[]) => {
    return data.map((item) => {
      const entityDisplay =
        entityNameMapping[item.entity] || item.entity || 'Unknown Entity';

      const updatedBy = item.entityUpdatedByUser?.name || 'System';
      const updatedAt = item.updatedAt
        ? new Date(item.updatedAt).toLocaleString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          })
        : 'Unknown Time';

      let oldValue = item.old_value?.value || '';
      let newValue = item.new_value?.value || '';

      if (item.entity === 'GAME_ASSIGN') {
        oldValue = item.old_value?.name || '';
        newValue = item.new_value?.name || '';
      }

      if (item.entity === 'GAME_QC_ASSIGN') {
        oldValue = item.old_value?.name || '';
        newValue = item.new_value?.name || '';
      }

      if (oldValue && newValue) {
        return `${entityDisplay} was changed by <strong>${updatedBy}</strong> on ${updatedAt}. The old value was "<strong>${oldValue}</strong>", the new value is "<strong>${newValue}</strong>".`;
      } else if (newValue) {
        return `${entityDisplay} was changed by <strong>${updatedBy}</strong> on ${updatedAt}. The new value is "<strong>${newValue}</strong>".`;
      } else {
        return `${entityDisplay} was changed by <strong>${updatedBy}</strong> on ${updatedAt}.`;
      }
    });
  };

  const formattedData = formatGameStatusChange(activityLog);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };

  return (
    <>
      <h2 style={{ alignItems: 'center', textAlign: 'center' }}>Game Report</h2>
      <Table>
        <TableBody>
          {formattedData.map((row, index) => (
            <TableRow key={index}>
              <TableCell align="left">
                <Typography
                  dangerouslySetInnerHTML={{
                    __html: row, // Use 'row' here as it contains the formatted string
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>{' '}
      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ActivityLog;
